<template>
  <div class="costumerRelation">
    <div v-if="isShowCostumerRelation" class="right">
      <div class="operation">
        <div class="operationBtn">
          <el-button @click="deleteData" :disabled="delDisabled">{{$t('LanguageLib.DELETE')}}</el-button>
          <el-button type="primary" @click="addCostumerRelation()">{{$t('LanguageLib.ADD_TO')}}</el-button>
          <el-button type="primary" :disabled="true"  @click="importExport()">{{$t('LanguageLib.ImportOrExport')}}</el-button>
        </div>
        <div class="operationSearch">
          <el-input
            placeholder=""
            prefix-icon="el-icon-search"
            v-model="searchText"
            @keyup.enter.native="searchDomainList"
          >
          </el-input>
        </div>
      </div>
      <div class="tableParent">
        <el-table
          empty-text=" "
          :data="tableData"
          @selection-change="onSelectedListChange"
          @sort-change='sortChange'
          height="100%"
          style="width: auto;"
          stripe
          v-loading="loading"
          ref="table"
        >
          <el-table-column
            type="selection"
            width="45"
            :selectable=selectInit>
          </el-table-column>

          <el-table-column
            prop="costumerCode"
            sortable="custom"
            :label="$t('LanguageLib.COSTUMER_CODE')"
            min-width="90">
          </el-table-column>

          <el-table-column
            prop="costumerName"
            sortable="custom"
            :label="$t('LanguageLib.COSTUMER_NAME')"
            min-width="90">
          </el-table-column>

          <el-table-column
            prop="updater"
            :label="$t('LanguageLib.UPDATED_BY')"
            min-width="90">
          </el-table-column>

          <el-table-column
            prop="updateTime"
            sortable="custom"
            :label="$t('LanguageLib.UPDATE_TIME')"
            min-width="90">
          </el-table-column>

          <el-table-column
            fixed="right"
            :label="$t('LanguageLib.Operation')"
            min-width="40">
            <template slot-scope="scope">
              <el-button
                @click.native.prevent="editCostumerRelation(scope.row, scope.$index, tableData)"
                :title="$t('LanguageLib.Edit')"
                type="text"
                style="color:#fff;width:30px;height:30px;background-color:#3bc6b9;border-radius:50%;line-height:30px;padding:0;">
                <i class="iconfont">&#xe60c;</i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageTotal">
      </el-pagination>
    </div>
    <router-view v-if="!isShowCostumerRelation">
    </router-view>
  </div>
</template>

<script>
import basicdataApi from '../../api/basicdata'

export default {
  data () {
    return {
      id: '',
      delDisabled: true,
      loading: false,
      pageTotal: 0,
      selectedList: [],
      tableData: [],
      searchText: '', // 列表搜索关键词
      currentPage: 1, // 当前页数
      pageSize: 20, // 默认每页显示20条数据
      sort: 0, // 排序字段
      prevSort: 'ascending', // 记录前一次的排序状态（elementUI默认有三种，即descending，ascending和null）
      prevProp: 'costumerCode', // 记录前一次的prop值
      sortOrder: true, // 排序方式:false=逆序：desc;true=正序asc
      updateRouteQuery: () => { // 刷新列表
        const query = this.$router.history.current.query
        const path = this.$router.history.current.path
        const newQuery = JSON.parse(JSON.stringify(query))
        console.log(newQuery)
        newQuery.currentPage = this.currentPage
        newQuery.pageSize = this.pageSize
        newQuery.searchText = this.$commonfun.encodeUrl(this.searchText)
        newQuery.sort = this.sort
        newQuery.sortOrder = this.sortOrder // 正序or逆序
        newQuery.NoRefresh = true
        this.$router.push({
          path,
          query: newQuery
        })
      },
      getCostumerRelationList: (pageIndex, pageSize, searchVal, sort, isAsc) => {
        this.loading = true
        // 排序字段
        // 0：编号
        // 1：客户名称
        // 2：更新用户
        // 3：更新时间
        basicdataApi.getCostumerRelationList('post', 'supplier/page', {
          pageIndex,
          pageSize,
          searchVal,
          sort,
          isAsc
        })
          .then(res => {
            let myData = res.data.data
            myData = myData.map(x => {
              x.costumerCode = x.code
              x.costumerName = x.name
              x.updater = x.updateUserName
              x.updateTime = x.updateDate.replaceAll('T', ' ').substring(0, 19)
              return x
            })
            console.log(myData)
            this.tableData = myData
            this.pageTotal = res.data.total
            this.loading = false
          })
          .catch(err => {
            this.$commonfun.console.log(err)
          })
      }
    }
  },
  computed: {
    isShowCostumerRelation: function () {
      const path = this.$route.path
      if (path.indexOf('/basicdata/costumerrelation') === -1) {
        return false
      } else {
        return true
      }
    }
  },
  mounted () {
    if (this.$route.query.currentPage) {
      this.currentPage = this.$route.query.currentPage * 1
      this.pageSize = this.$route.query.pageSize * 1
      this.searchText = this.$commonfun.decodeUrl(this.$route.query.searchText)
      this.sort = this.$route.query.sort * 1
      this.sortOrder = JSON.parse(this.$route.query.sortOrder)
    }
    this.getCostumerRelationList(this.currentPage, this.pageSize, this.searchText, this.sort, this.sortOrder)
    console.log(this.$route.path)
  },
  methods: {
    onSelectedListChange (selectedList) {
      this.selectedList = selectedList
      if (this.selectedList.length === 0) {
        this.delDisabled = true
      } else {
        this.delDisabled = false
      }
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.updateRouteQuery()
      this.getCostumerRelationList(this.currentPage, this.pageSize, this.searchText, this.sort, this.sortOrder)
    },
    selectInit (row, index) {
      return true
    },
    sortChange (column) {
      console.log(column)
      if (column.order !== null) {
        this.prevSort = column.order
        if (column.order === 'ascending') {
          this.sortOrder = true
          this.prevSort = 'ascending'
        } else if (column.order === 'descending') {
          this.prevSort = 'descending'
          this.sortOrder = false
        }
        if (this.prevProp !== column.prop) {
          var columns = this.$refs.table.columns.find(item => item.property === this.prevProp)
          columns.order = ''
        }
      }
      if (column.order === null) {
        column.column.order = this.prevSort === 'descending' ? 'ascending' : 'descending'
        column.order = this.prevSort === 'descending' ? 'ascending' : 'descending'
        this.prevProp = column.prop
        this.prevSort = column.column.order
        this.sortOrder = column.column.order !== 'descending'
      }
      switch (column.prop) {
        case 'costumerCode':
          this.sort = 0
          break
        case 'costumerName':
          this.sort = 1
          break
        case 'updater':
          this.sort = 2
          break
        case 'updateTime':
          this.sort = 3
          break
      }
      this.getCostumerRelationList(this.currentPage, this.pageSize, this.searchText, this.sort, this.sortOrder)
    },
    importExport () {
      console.log('点击了导入导出')
    },

    deleteData () {
      this.$commonfun.confirm(this.$t('LanguageLib.ARE_YOU_SURE_YOU_WANT_TO_DELETE_IT1'), this.$t('LanguageLib.DELETE'), this.$t('LanguageLib.DETERMINE'), this.$t('LanguageLib.CANCEL'), false, 'warning', this)
        .then(() => {
          console.log(this.selectedList)
          this.selectedList = this.selectedList.map(x => {
            return x.id
          })
          console.log(this.selectedList)
          basicdataApi.deleteCostumerRelation('post', '/supplier/delete', this.selectedList)
            .then((res) => {
              console.log(res)
              this.getCostumerRelationList(this.currentPage, this.pageSize, this.searchText, this.sort, this.sortOrder)
              if (res.data.failCount === 0) {
                // 删除全部成功
                console.log('全部成功')
                this.$message({
                  type: 'success',
                  message: this.$t('LanguageLib.SUCCESSFULLY_DELETED')
                })
              } else if (res.data.successCount === 0) {
                // 全部失败
                console.log('全部失败')
                this.$message({
                  type: 'error',
                  message: this.$commonfun.stringFormat(this.$t('LanguageLib.SELECTED_OPERATION_FAIL'), this.$t('LanguageLib.Rebinding'))
                })
              } else {
                console.log('有成功有失败')
                // 有成功有失败
                this.$message({
                  type: 'info',
                  message: this.$commonfun.stringFormat(this.$t('LanguageLib.SELECTED_ORGANIZATION_TO_STORE_INFO'), res.data.successCount, res.data.failCount, this.$t('LanguageLib.DELETE'), this.$t('LanguageLib.DELETE'))
                })
              }
            }
            )
        }).catch()

      console.log('点击了删除')
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.updateRouteQuery()
      // 请求列表接口数据
      this.getCostumerRelationList(this.currentPage, this.pageSize, this.searchText, this.sort, this.sortOrder)
    },
    searchDomainList () {
      this.updateRouteQuery()
      this.currentPage = 1
      this.getCostumerRelationList(this.currentPage, this.pageSize, this.searchText, this.sort, this.sortOrder)
    },
    // 编辑客户关系
    editCostumerRelation (data, index, tableData) {
      console.log(data)
      this.$router.push('/basicdata/EditCostumerRelation?currentPage=' + this.currentPage + '&pageSize=' + this.pageSize + '&searchText=' + this.$commonfun.encodeUrl(this.searchText) + '&sort=' + this.sort + '&sortOrder=' + this.sortOrder + '&type=edit&costumerCode=' + data.costumerCode + '&costumerName=' + data.costumerName + '&id=' + data.id)
    },
    // 添加客户关系
    addCostumerRelation (data) {
      this.$router.push('/basicdata/EditCostumerRelation?currentPage=' + this.currentPage + '&pageSize=' + this.pageSize + '&searchText=' + this.$commonfun.encodeUrl(this.searchText) + '&sort=' + this.sort + '&sortOrder=' + this.sortOrder + '&type=add')
    }
  }
}
</script>

<style lang="scss">
  .costumerRelation {
    height: 100%;
    width: 100%;

    .right {
      width: 100%;
      height: 100%;

      .operation {
        background: #fff;
        height: 30px;
        padding: 10px 0 10px 20px;
        border-bottom: 1px solid #f2f2f2;
        border-top: 1px solid #f2f2f2;

        .operationBtn {
          width: auto;
          display: inline-block;
          float: left;
          position: relative;

          .el-button {
            height: 30px;
            padding: 7px 20px;
          }

          .BatchSetting {
            background: #fff;
            color: #666666;
            position: absolute;
            left: 0;
            top: 30px;
            width: 100px;
            font-size: 14px;
            text-align: center;
            box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.2);
            border-radius: 2px;
            z-index: 99;

            li {
              line-height: 30px;
              cursor: pointer;
            }
          }

          .exportType {
            min-width: 100px;
            background: #fff;
            color: #666666;
            position: absolute;
            right: 0;
            top: 30px;
            font-size: 14px;
            text-align: center;
            box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.2);
            border-radius: 2px;
            z-index: 99;

            li {
              line-height: 30px;
              cursor: pointer;
            }
          }
        }

        .operationSearch {
          float: right;
          padding-right: 51px;
          position: relative;

          .shaixuan {
            color: #999999;
            height: 15px;
            width: 15px;
            position: relative;
            top: 2px;
            margin-left: 10px;
            margin-right: 10px;
            font-weight: 600;
          }

          .shaixuan1 {
            color: #3BC6B9;
          }

          .el-input {
            width: 160px;

            .el-input__inner {
              height: 30px;
              line-height: 30px;
              border-radius: 20px;
            }
          }

          .el-icon-search {
            line-height: 30px;
          }
        }
      }

      .tableParent {
        height: calc(100% - 98px);
      }

      .el-pagination {
        padding: 8px 15px 5px;
        height: 35px;
        background: #fff;
      }
    }

    .el-button--default {
      border: 1px solid #3BC6B9;
      color: #3BC6B9;
    }

    .el-button--primary {
      background-color: #3BC6B9;
      color: #fff;
      border: none;
      margin-left: 10px;
    }

    .el-button--primary:hover {
      background-color: #3BC6B9;
      color: #fff;
      border: none;
    }
  }

</style>
